var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShouji(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.035 21.289c0 .175-.027.344-.076.502a2.635 2.635 0 01-2.545 1.988H2.636c-1.224 0-2.259-.85-2.544-1.99a1.637 1.637 0 01-.077-.5V2.642A2.63 2.63 0 012.636.021h10.778a2.63 2.63 0 012.621 2.621zm-8.04-2.17a1.33 1.33 0 00-1.324 1.325 1.33 1.33 0 001.325 1.325 1.33 1.33 0 001.325-1.325 1.33 1.33 0 00-1.325-1.325zM13.415 2.03H2.636c-.48 0-.873.37-.873.822l-.001 15.493h12.525V2.853c0-.417-.335-.764-.764-.815l-.11-.007z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
}

export default SvgShouji;